import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
});

export const cnatApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/ticketing-portal/cnat-2025',
});

cnatApi.interceptors.response.use((config) => {
  if (config.status === 401) {
    window.location.href = '/login';
  }
  return config;
});

const ADMIN_DEFAULT_MASTER_ORGANIZATION = '650bd89479ba3ae92524955b';

export const adminApi = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/ticketing-portal/cnat-2025/admin',
});

// Add request interceptor to include masterOrganization in every request
adminApi.interceptors.request.use((config) => {
  config.params = config.params || {};
  // Only set masterOrganization if not already provided
  if (!config.params.masterOrganization) {
    config.params.masterOrganization = ADMIN_DEFAULT_MASTER_ORGANIZATION;
  }
  return config;
});

adminApi.interceptors.response.use((config) => {
  if (config.status === 401) {
    window.location.href = '/admin/login';
  }
  return config;
});

export const fetchTranslations = () => {
  return api.get('/public/translations/cnat-ticketing-portal');
};

export const getWSFRegionalInformation = async (params) => {
  const url =
    `https://data.education.gouv.fr/api/explore/v2.1/catalog/datasets/fr-en-annuaire-education/records?` +
    new URLSearchParams({ limit: 20, ...params });
  const response = await fetch(url, {
    method: 'GET',
  });
  const data = await response.json();
  return data;
};

export const getBookedTimeSlots = async (masterOrganization = '650bd89479ba3ae92524955b') => {
  return cnatApi.get('/booked-time-slots', {
    params: {
      masterOrganization,
    },
  });
};

export const schoolRegistration = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return cnatApi.post('/school-registration', {
    ...body,
    masterOrganization,
  });
};

export const otherGroupsRegistration = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return cnatApi.post('/other-groups-registration', {
    ...body,
    masterOrganization,
  });
};

export const login = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return api.post('/auth/cnat2025', {
    ...body,
    masterOrganization,
  });
};

export const validateMagic = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return api.post('/auth/cnat2025-magic', {
    ...body,
    masterOrganization,
  });
};

export const getDashboardDetails = () => {
  return cnatApi.get('/me');
};

export const updateDashboardDetails = (body) => {
  return cnatApi.put('/me', body);
};

export const adminLogin = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return api.post('/auth/cnat2025/admin', {
    ...body,
    masterOrganization,
  });
};

export const validateAdminMagic = (body, masterOrganization = '650bd89479ba3ae92524955b') => {
  return api.post('/auth/cnat2025/admin-magic', {
    ...body,
    masterOrganization,
  });
};

export const getRegistrationStats = () => {
  return adminApi.get('/registration-stats');
};

export const getDateRegistrationStats = (registrationType = null) => {
  const params = {};
  if (registrationType && registrationType !== 'all') {
    params.registrationType = registrationType;
  }
  return adminApi.get('/date-registration-stats', { params });
};

export const getHourlyTimeSlotStats = (registrationType = null) => {
  const params = {};
  if (registrationType && registrationType !== 'all') {
    params.registrationType = registrationType;
  }
  return adminApi.get('/hourly-time-slot-stats', { params });
};

export const getRegistrationsList = (
  registrationType = 'all',
  type = 'all',
  page = 1,
  limit = 10,
) => {
  return adminApi.get('/registrations-list', {
    params: {
      registrationType,
      type,
      page,
      limit,
    },
  });
};

export const getRegistrationDetails = (id) => {
  return adminApi.get(`/registration-details/${id}`);
};

export const updateRegistrationDetails = (id, body) => {
  return adminApi.put(`/registration-details/${id}`, body);
};

export const deleteRegistration = (id, emailData) => {
  return adminApi.delete(`/registration-details/${id}`, {
    data: emailData,
  });
};

export const exportData = (exportOptions, signal) => {
  return adminApi.post(
    '/export-data',
    {
      ...exportOptions,
    },
    {
      signal,
    },
  );
};

export const sendEmailMessage = (emailOptions, signal) => {
  return adminApi.post(
    '/send-email-message',
    {
      ...emailOptions,
    },
    {
      signal,
    },
  );
};

export const getSlotReservationStats = (type) => {
  return adminApi.get(`/slots-reservation-stats/${type}`);
};
